export default "__VITE_ASSET__wO0dB8s1__"